<script>
import resources from './resources'

export default {
  name: 'covenants',
  mixins: [resources]
}
</script>

<template lang="pug">
  page(icon='', title='Meus Convênios')
    .col-xs-12.content
      .container-fluid.zero-margin
        .row
          card-add(
            label='Adicionar<br>Novo Convênio',
            route='settings.covenants.create',
            icon='')
          covenant(
            @on-delete="doDelete",
            v-for="covenant in covenants",
            :key="covenant.id",
            :covenant="covenant",
            @on-active="doActive")
      .pagination
        pagination(:pagination="pagination", @pagination-changed-page="setPage")
</template>



// WEBPACK FOOTER //
// src/app/settings/covenants/index/covenants.vue